module.exports = __webpack_public_path__ + "img/comments-inbox.885b3706.svg";